<div class="d-flex flex-column align-items-center">
    <ion-icon class="mb-3" size="large" icon="file-tray-full-outline"></ion-icon>
    <div class="ion-text-center">{{label}}</div>
</div>